export const namespaced = true;

export const state = {
    version: null,
    loading: false,
    updatingProgress: null,
};

export const mutations = {
    FETCH_VERSION(state, version) {
        state.version = version;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_UPDATING_PROGRESS(state, info) {
        state.updatingProgress = info;
    },
};

export const actions = {
    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/version`)).data;
            if (res.data) {
                commit("FETCH_VERSION", res.data);
                return res.data;
            }
            return null;
        } catch (error) {
            const notification = {
                version: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message,
            };
            dispatch("notification/add", notification, { root: true });
        }
    },
    async checkUpdates({ commit, state, dispatch }) {
        try {
            const res = (await axios.post(`/api/admin/version-check`)).data;
            dispatch("fetch");
            const notification = {
                type: "success",
                message: "Проверка завершена",
            };
            dispatch("notification/add", notification, { root: true });
        } catch (error) {
            const notification = {
                type: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message,
            };
            dispatch("notification/add", notification, { root: true });
        }
    },

    async checkUpgradeInfo({ commit, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/get-updates-processing`))
                .data;

            commit("SET_UPDATING_PROGRESS", res);

            if (res.finished_at) {
                dispatch("fetch");
                commit("SET_LOADING", false);
            }
        } catch (error) {
            const notification = {
                type: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message,
            };
            dispatch("notification/add", notification, { root: true });
        }
    },

    async install({ commit, state, dispatch }) {
        try {
            commit("SET_LOADING", true);
            await axios.post(`/api/admin/upgrade/init`);
        } catch (error) {
            const notification = {
                type: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message,
            };
            dispatch("notification/add", notification, { root: true });
        } finally {
            dispatch("checkUpgradeInfo");
            commit("SET_LOADING", false);
        }
        dispatch("checkUpgradeInfo");
    },

    async clearUpgrade({ commit, state, dispatch }) {
        try {
            commit("SET_LOADING", true);
            await axios.delete(`/api/admin/upgrade/clear`);
            dispatch("checkUpgradeInfo");
            commit("SET_LOADING", false);
        } catch (error) {
            const notification = {
                type: "error",
                message:
                    error.response &&
                    error.response.data &&
                    error.response.data.message,
            };
            dispatch("notification/add", notification, { root: true });
        }
    },
};
